/* eslint-disable @typescript-eslint/no-unsafe-assignment */
/* eslint-disable camelcase */
import dutchMessages from 'ra-language-dutch'
import { StringMap } from 'react-admin'

export const i18nDutch: StringMap = {
  ...dutchMessages,
  dashboard: {
    greeting: {
      morning: 'Goedemorgen',
      afternoon: 'Goedemiddag',
      evening: 'Goedenavond',
    },
    description: 'Welkom bij xxllnc Certificaten.',
    descriptionAdmin: 'Welkom bij xxllnc Certificaten.',
  },
  resources: {
    certificates: {
      list: 'Certificaten',
      edit: 'Gegevens aanpassen',
      show: 'Certificaat details',
      create: 'Certificaat aanvragen',
      title: 'Certificaten',
      search: 'Zoek op hostnaam of contact',
      subtitle: 'Certificaten van je koppelingen: aanvragen, installeren en op tijd vernieuwen.',
      actions: {
        createCsr: 'CSR aanmaken',
        uploadCertificate: 'Upload certificaat',
        scheduleInstallation: 'Installatie inplannen',
        cancelInstallation: 'Annuleer installatie',
        renew: 'Vernieuw certificaat',
        renewSuccess: 'Certificaat vernieuwing geinitieerd',
        renewCsr: 'Nieuwe CSR aanmaken',
        csrDownloaded: 'CSR succesvol gedownload',
        downloadCertificate: 'Download certificaat',
        certificateUploaded: 'Certificaat succesvol geüpload',
        certificateDownloaded: 'Certificaat succesvol gedownload',
        installNow: 'Nu installeren',
      },
      sections: {
        targetSystem: 'Doelsysteem',
        targetSystemHelp: 'Het systeem en de gemeente waarvoor het certificaat is.',
        contact: 'Contact',
        contactHelp: 'Wie we mailen over dit certificaat.',
        certificate: 'Certificaat',
        certificateHelp: 'Type en hostnaam van het certificaat.',
      },
      fields: {
        properties: 'Eigenschappen',
        kind: 'Soort',
        interface: 'Koppelvlak',
        instance: 'Omgeving',
        host: 'Hostnaam',
        title: 'Titel',
        type: 'Type',
        organisatienaam: 'Organisatienaam',
        provincie: 'Provincie',
        plaatsnaam: 'Plaatsnaam',
        webadres: 'Gewenst webadres',
        webadres_help: 'Het webadres waarvoor het PKI certificaat gebruikt gaat worden. Bijvoorbeeld mijn.gemeente.nl',
        samlKoppeling: 'Soort koppeling',
        samlKoppeling_help: 'Voor welke SAML Koppeling er een certificaat nodig is.',
        samlidp: 'DigiD, eHerkenning en eIDAS',
        stufconfig: 'StUF Koppeling Configuratie',
        stuf_dcr: 'StUF Document Creatie',
        stuf_zkn_client: 'StUF Zaken Client',
        xential: 'Xential',
        api: 'Zaken API',
        event_sink: 'Event Sink',
        export_queue: 'Export Queue',
        gws4all: 'GWS4All',
        omgeving: 'Voor welke omgeving',
        omgeving_help: 'Omgeving url in deze vorm: mijn.gemeente.nl of mijn.alkmaar.nl, ' +
        'niet https://mijn.gemeente.nl of mijn.gemeente.nl/intern',
        koppelvlakId: 'ID van het koppelvlak',
        koppelvlakId_help: 'Koppelvlak ID is het nummer wat achter de naam van de koppeling staat. ' +
        'Bijvoorbeeld StUF Koppeling Configuratie stufconfig(5). Het nummer is in dit geval 5.',
        certificaatId: 'ID van het certificaat',
        municipality: 'Gemeente',
        status: 'Status',
        verloopDatum: 'Verloopdatum',
        targetSystem: 'Doelsysteem',
        geldigheid: 'Geldigheid',
        link: 'Koppeling',
        certificate: 'Certificaat',
        created: 'Aangemaakt',
      },
      empty: {
        title: 'Nog geen certificaten',
        text: 'Vraag een certificaat aan om te beginnen.',
        textReadOnly: 'Er zijn nog geen certificaten aangemaakt.',
      },
      validity: {
        expired: 'Verlopen',
        daysLeft: 'Nog %{smart_count} dag |||| Nog %{smart_count} dagen',
      },
      tooltips: {
        expiredOn: 'Verlopen op %{date}',
        expiresOn: 'Verloopt op %{date}',
      },
      detail: {
        nextStep: 'Volgende stap',
      },
      alerts: {
        expired: 'Certificaat is verlopen op %{date}',
        expiresSoon: 'Certificaat verloopt over %{days} dagen op %{date}',
        expiresOn: 'Certificaat verloopt op %{date}',
        noMunicipalityConfigured: 'U kunt nog geen certificaat aanmaken omdat er geen gemeente is geconfigureerd.',
      },
      types: {
        pki: 'PKI',
        zaak_client: 'Client',
      },
      targetSystems: {
        zaken: 'Zaken',
        waarderen: 'Waarderen',
        heffen_en_innen: 'Heffen en Innen',
      },
      status: {
        PENDING: 'In afwachting',
        CSR_READY: 'CSR gegenereerd',
        CSR_DOWNLOADED: 'CSR gedownload',
        CERT_UPLOADED: 'Certificaat geüpload',
        INSTALL_SCHEDULED: 'Installatie ingepland',
        ACTIVE: 'Actief',
        EXPIRED: 'Verlopen',
        ERROR: 'Fout',
      },
    },
    municipality: {
      list: 'Gemeenten',
      edit: 'Gemeente bewerken',
      show: 'Gemeente',
      create: 'Gemeente toevoegen',
      title: 'Gemeenten',
      fields: {
        organisatienaam: 'Organisatienaam',
        plaatsnaam: 'Plaatsnaam',
        provincie: 'Provincie',
        contactpersoon: 'Contactpersoon',
      },
    },
    organization: {
      list: 'Organisaties',
      edit: 'Organisatie bewerken',
      create: 'Organisatie aanmaken',
      title: 'Organisaties',
      fields: {
        name: 'Naam',
        organizationId: 'Auth0-organisatie-id',
        auth0: 'Auth0-organisatie',
        apps: 'Gekoppelde apps',
      },
      apps: {
        zaken: 'Zaken klant',
      },
      inUseBy: 'gekoppeld aan %{name}',
      sourceUnavailable: 'Bron niet beschikbaar: %{source}. Opslaan is uitgeschakeld.',
      nameMismatch: 'Naam "%{appName}" wijkt af van de Auth0-naam "%{auth0Name}".',
      locked: 'Er zijn certificaten voor deze organisatie; de koppeling kan niet meer gewijzigd worden.',
      authImmutable: 'Het Auth0-id is na opslaan niet meer te wijzigen.',
      confirmTitle: 'Organisatie opslaan?',
      confirmContent: 'Het Auth0-id kan later niet gewijzigd worden.',
      created: 'Organisatie aangemaakt',
      switchTo: 'Wissel naar deze organisatie',
      close: 'Sluiten',
    },
    schedule: {
      fields: {
        installationDatum: 'Installatiedatum',
        dateFieldHelper: 'De tijd zal worden afgerond naar het eerstvolgende hele uur.'
      },
      status: {
        PENDING: 'Installatie ingepland op %{date}',
        COMPLETED: 'Installatie voltooid op %{date}',
        CANCELED: 'Installatie van %{date} geannuleerd',
        ERROR: 'Installatie mislukt op %{date}',
      },
      actions: {
        scheduleInstallationTitle: 'Certificaat installatie inplannen',
        scheduleInstallationSubtitle: 'Kies een datum en tijd voor de installatie van het certificaat',
        dateMustBeInFuture: 'De datum moet in de toekomst liggen',
        canceled: 'Installatie succesvol geannuleerd',
        installationScheduledNow: 'Installatie gestart',
      },
    },
  },
  filters: {
    title: 'Filters',
    show: 'Filters tonen',
    hide: 'Filters verbergen',
    status: 'Status',
  },
  data: {
    selectOrganization: 'Kies een organisatie',
    organizationSwitched: 'Gewisseld naar %{name}',
    schedule: 'Installatieplanning',
    installationDatum: 'Installatiedatum',
    log: 'Logboek',
    properties: 'Eigenschappen',
    lastUpdated: 'Laatst bijgewerkt',
    certificate: 'Certificaat',
    created: 'Aangemaakt op',
    contactpersoon: 'Contactpersoon',
    phone: 'Telefoonnummer',
    email: 'E-mailadres',
    koppelvlak: 'Koppelvlak',
  },
  login: {
    title: 'Inloggen',
    button: 'Inloggen',
    choose: 'Kies voor welke organisatie je wilt inloggen:',
    email: 'Email',
    emailHint: 'Vul je emailadres in om door te gaan.',
    fetchUserInfo: 'Een moment geduld, we halen je gebruikersinformatie op.',
    hint: 'Log in op xxllnc Certificaten',
    incognitoError: 'Authenticatie niet mogelijk in incognito mode',
    loginCompleted: 'Succesvol ingelogd!',
    unknownOrganizationId: 'Het opgegeven organisatie-id is onbekend',
    notValid: 'Het opgegeven emailadres is niet geldig',
    byXxllnc: 'Certificaten is een applicatie van xxllnc',
    inactive: 'Je bent uitgelogd vanwege inactiviteit.',
  },
  page: {
    unauthorized: {
      headerTitle: 'Onbevoegd',
      defaultTitle: 'Onbevoegd',
      title: 'Voor deze actie ben je niet bevoegd.',
      text: 'Je hebt geprobeerd een actie uit te voeren waar je geen rechten voor hebt.',
    },
  },
  settings: {
    tabs: {
      details: 'Details',
      certificates: 'Certificaten',
      logs: 'Logboek',
    },
    municipality: {
      noCertificatesText: 'Voor deze gemeente zijn nog geen certificaten aangemaakt.',
      sectionMunicipality: 'Gemeente',
      sectionMunicipalityHelp: 'Naam en ligging van de gemeente.',
      sectionContact: 'Contact',
      sectionContactHelp: 'Aanspreekpunt voor certificaten van deze gemeente.',
      emptyTitle: 'Nog geen gemeenten',
      emptyText: 'Voeg een gemeente toe om te beginnen.',
      emptyTextReadOnly: 'Er zijn nog geen gemeenten aangemaakt.',
    },
    organization: {
      noCertificatesText: 'Deze organisatie heeft nog geen certificaten.',
      hasCertificates: 'Heeft certificaten',
      yes: 'Ja',
      no: 'Nee',
      sectionAuth0: 'Auth0',
      sectionAuth0Help: 'De organisatie in Auth0 waaraan deze organisatie gekoppeld is.',
      sectionName: 'Naam',
      sectionNameHelp: 'Weergavenaam in dit portaal.',
      sectionLinks: 'Koppelingen',
      sectionLinksHelp: 'Koppel de organisatie aan apps van het Zaken-ecosysteem.',
      search: 'Zoek op naam',
      emptyTitle: 'Nog geen organisaties',
      emptyText: 'Maak een organisatie aan om te beginnen.',
    },
  },
  submenu: {
    settings: 'Instellingen',
  },
  ui: {
    accountMenu: 'Account',
    limited: 'Laatste %{limit} van %{total}',
  },
  validation: {
    hostname: 'Ongeldige hostnaam, bijvoorbeeld mijn.gemeente.nl',
  },
}
